import { render, staticRenderFns } from "./SurveySubmit.vue?vue&type=template&id=4084f3b0&scoped=true"
import script from "./SurveySubmit.vue?vue&type=script&lang=js"
export * from "./SurveySubmit.vue?vue&type=script&lang=js"
import style0 from "./SurveySubmit.vue?vue&type=style&index=0&id=4084f3b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4084f3b0",
  null
  
)

export default component.exports